import { render, staticRenderFns } from "./MultipleReferenceCompact.vue?vue&type=template&id=7a55cd8e"
import script from "./MultipleReferenceCompact.vue?vue&type=script&lang=js"
export * from "./MultipleReferenceCompact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports